import { useState, createContext, useMemo } from 'react';

const context = {};

export const FiltersContext = createContext(context);

export function FiltersContextProvider(props) {
  const [filterToggle, setFilterToggle] = useState(false);
  const [overlay, setOverlay] = useState(false);

  const toggleFilter = () => {
    setFilterToggle(!filterToggle);
  };

  const contextValues = useMemo(
    () => ({
      filterState: filterToggle,
      toggleFilter,
      overlay,
      setOverlay,
      setFilterToggle,
    }),
    [filterToggle, toggleFilter],
  );

  return <FiltersContext.Provider value={contextValues}>{props.children}</FiltersContext.Provider>;
}
